import { CSSObject } from "@emotion/react";

// Colors
const coreBlue = { 700: "#0052C4", 500: "#106FF3" };
const white = "#FFFFFF";

const flexColumn: CSSObject = {
  display: "flex",
  flexDirection: "column",
};

// Main container
export const containerStyles: CSSObject = {
  ...flexColumn,
  backgroundColor: white,
  width: "100%",
  padding: "16px",
  boxSizing: "border-box",
  fontFamily: "inherit",
  fontSize: "0.9em",
  maxWidth: 1100,
  margin: "0 auto",
  height: "100%",
  maxHeight: "800px",
};

// Excerpt section with blue border
export const excerptContainer: CSSObject = {
  border: `4px solid ${coreBlue[500]}`,
  borderRadius: "1.5em",
  padding: "0.6em",
  margin: "0.4em 0",
  display: "flex",
  alignItems: "center",
  height: "60px",
};

export const excerptStyles: CSSObject = {
  fontSize: "0.9em",
  marginRight: "0.5em",
  lineHeight: 1.2,
};

export const excerptTextareaStyles: CSSObject = {
  alignItems: "center",
  backgroundColor: "transparent",
  resize: "none",
  flex: 1,
  fontFamily: "inherit",
  "&:focus": {
    outline: "none",
  },
};

export const inputLabelStyles: CSSObject = {
  fontWeight: "bold",
  fontSize: "0.9em",
  marginRight: "0.5em",
  width: "110px",
  height: "60px",
};

export const inputContainer: CSSObject = {
  marginBottom: "0.5em",
  display: "flex",
  alignItems: "center",
  borderBottom: `2px solid  ${coreBlue[500]}`,
};

export const textareaStyles: CSSObject = {
  width: "100%",
  height: "85px",
  resize: "none",
  borderRadius: "1em",
  overflow: "hidden",
  padding: "5px",
  marginBottom: "5px",
  backgroundColor: "transparent",
  fontFamily: "inherit",
};
